import { Box, Link, Text } from '@nimbus-ds/components';
import { AlertSessionStorage } from 'App/components';
import { useTranslationMarketing } from 'domains/Marketing/hook';

interface PaymentOptionsDisabledAlertProps {
  handleGoToPayments: () => void;
  keyName: string;
}

export function PaymentOptionsDisabledAlert({
  handleGoToPayments,
  keyName,
}: Readonly<PaymentOptionsDisabledAlertProps>): JSX.Element {
  const t = useTranslationMarketing(
    'promotions.settingsPage.limits.paymentOptions.modal.disabledWarning',
  );

  return (
    <Box display="flex" alignItems="center" my="1">
      <AlertSessionStorage appearance="primary" keyName={keyName}>
        <Text color="primary-textHigh" fontWeight="bold" lineHeight="base">
          {t('title')}
        </Text>
        <Text>{t('description')}</Text>
        <Link onClick={handleGoToPayments}>{t('ctaText')}</Link>
      </AlertSessionStorage>
    </Box>
  );
}
